import Codenames from "./Codenames";

const penguinCodenamesGame = {
  slug: "codenames-pictures",
  name: "Codenames",
  landing: {
    accentColor: "#3d6b92",
    penguinPose: "penguin-left",
  },
  component: Codenames,
};

export default penguinCodenamesGame;
